import { Checkbox, Radio, RadioChangeEvent, Rate, Space } from "antd";
import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { CiHeart } from "react-icons/ci";
import { GoShareAndroid } from "react-icons/go";
import { IoSearchOutline } from "react-icons/io5";
import TVDesc from "./TVDesc";
import { IoIosArrowUp } from "react-icons/io";

const TVDetails = () => {
  const [value, setValue] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const visibleImagesCount = 3; 

  const onChange = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const listArray=["/assets/tv.png","/assets/proddeal.png","/assets/laptop.png","/assets/proddeal.png","/assets/laptop.png"]
  const [currentIndex,setcurrentIndex]=useState(0)
  const handlenextvimg=()=>{
    if (startIndex + visibleImagesCount < listArray.length) {
        setStartIndex(startIndex + 1);
      }
  }

  const handleprevimg=()=>{
    if (startIndex > 0) {
        setStartIndex(startIndex - 1);
      }
  }

  const handleDisplayimage=(index:any)=>{
    setcurrentIndex(index)
  }
  return (
    <>
      <section className="pb-4" style={{ paddingTop: "6rem" }}>
        <Container>
          <div>
            <p className="title-para">
              Home - Products-TV-Samsung 
            </p>
            <h2 className="title-navhead">Products</h2>
          </div>
          <div className="row pt-4 pb-3">
          <div className="col-lg-1 col-md-3 col-sm-12 col-12">
              <div className="na-div">
                <div className="d-flex justify-content-center align-items-center">
                  <div className="upicons" onClick={handlenextvimg}>
                    <IoIosArrowUp />
                  </div>
                </div>
                <div className="map-div">
                  {listArray
                    .slice(startIndex, startIndex + visibleImagesCount)
                    .map((imgSrc, index) => {
                      const realIndex = startIndex + index; // Calculate the real index
                      return (
                        <div
                          className={`arr-div ${
                            currentIndex === realIndex ? "active-thumbnail" : ""
                          }`}
                          key={realIndex}
                          onClick={() => handleDisplayimage(realIndex)} // Pass the real index
                        >
                          <img src={imgSrc} className="img-fluid" />
                        </div>
                      );
                    })}
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="downicons" onClick={handleprevimg}>
                    <IoIosArrowUp />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-9 col-sm-12 col-12 p-2">
              <div className="prod-con">
                <div className="">
                  <img
                    src={listArray[currentIndex]}
                    className="img-fluid proddeal-img mt-5"
                  />
                </div>
                <div className="deal-img">
                  <img className="img-fluid" src="/assets/deal.png" />
                </div>
                <div className="deal-imgicon">
                  <CiHeart className="me-2" style={{ cursor: "pointer" }} />
                  <GoShareAndroid style={{ cursor: "pointer" }} />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 p-2">
              <div className="details-box">
                <div>
                  <h3>
                  Samsung 138 cm (55in) QE1D series 4k ultra HD QLED smart tv (Black)
                  </h3>
                  <Rate disabled defaultValue={2} style={{fontSize:"14px"}}/>
                  <span className="prod-rateing"> 4.0|5k Bought</span>
                  <p className="prod-id">
                    <span><strong>Product id :</strong></span> 45784{" "}
                    <span
                      className="px-2 py-1"
                      style={{
                        backgroundColor: "#2FB300",
                        borderRadius: "20px",
                        height: "15px",
                        width: "50px",
                        color: "#fff",
                        fontSize: "10px",
                      }}
                    >
                      In Stock
                    </span>
                  </p>
                  <h3>Size (In Inch)</h3>
                  <div className="py-2">
                    <Button className="ram-btn">40.9 </Button>
                  </div>
                  <h3>Enter your pincode</h3>
                  <div className="pin-code">
                    <input />
                    <Button>
                      <IoSearchOutline />
                    </Button>
                  </div>
                  <span className="del">Delivery by today</span>
                  <h3 className="pt-3">Delivery Type</h3>
                  <div>
                    <Radio.Group onChange={onChange} value={value}>
                      <Space direction="vertical">
                        <Radio value={1}>Standard Delivery</Radio>
                        <Radio value={2}>Express Delivery(₹ 100)</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <h3 className="pt-3">Exchange Type</h3>
                  <div>
                    <Radio.Group onChange={onChange} value={value}>
                      <Space direction="vertical">
                        <Radio value={1}>With Exchange</Radio>
                        <Radio value={2}>Without Exchange</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <h3 className="pt-3">Description</h3>
                  <table>
                    <tr>
                      <td className="td-desc">Brand</td>
                      <td className="td-descCon">: Samsung</td>
                    </tr>
                    <tr>
                      <td className="td-desc">Display technology</td>
                      <td className="td-descCon">: QLED</td>
                    </tr>
                    <tr>
                      <td className="td-desc">Resolution</td>
                      <td className="td-descCon">: 4K</td>
                    </tr>
                    <tr>
                      <td className="td-desc">
                      Reference rate  </td>
                      <td className="td-descCon">: 5Hz</td>
                    </tr>
                    <tr>
                      <td className="td-desc">
                      Special feature  </td>
                      <td className="td-descCon">: Quantum Processor Lite 4K|Quantum HDR|4K Upscaling|Dual LED</td>
                    </tr>
                 
                  </table>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center pt-3">
                <div><span className="detaisl-mrp">MRP:₹ <span style={{textDecoration:"line-through"}}>12121</span><span className="ms-2" style={{color:"#2FB300"}}>10%</span></span><p className="mb-0 detail-price">₹ 19,499.00</p></div>
                <Button variant="primary" className="buy-now">Buy Now</Button>
                <Button className="cart-button" style={{cursor:"pointer"}}>
                <AiOutlineShoppingCart />
                </Button>
                </div>
                <div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-12 col-12 p-2">
              <div className="details-box">
                <h4 className="mb-0">Bought Together</h4>
                <div className="d-flex justify-content-between align-items-center pt-3 check">
                  <div>
                <Checkbox onChange={onChange}></Checkbox>
                </div>
                <div className="extra-img">
                  <img src="/assets/proddeal.png" className="img-fluid" />
                </div>
                <div className="extra-deatos">
                  <p className="mb-0">Samsung Galaxy A15 5G</p>
                  <p className="mb-0">( 8 GB , 156 GB storage )</p>
                  <h5 className="mb-0 pt-1">₹ 19,499.00</h5>
                </div>
                </div>
                <div className="d-flex justify-content-between align-items-center pt-3 check">
                  <div>
                <Checkbox onChange={onChange}></Checkbox>
                </div>
                <div className="extra-img">
                  <img src="/assets/proddeal.png" className="img-fluid" />
                </div>
                <div className="extra-deatos">
                  <p className="mb-0">Samsung Galaxy A15 5G</p>
                  <p className="mb-0">( 8 GB , 156 GB storage )</p>
                  <h5 className="mb-0 pt-1">₹ 19,499.00</h5>
                </div>
                </div>
                <div className="pt-4">
                  <p className="ons-items">Your item + Add-ons(1)=Total</p>
                  <p className="onsprie"><span>₹ 19,499.00</span><span>₹ 19,499.00</span><span>₹ 19,499.00</span></p>
                </div>
                <div className="text-center pt-4">
                <Button variant="primary" className="buy-now">Add to cart </Button>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <TVDesc/>
    </>
  );
};

export default TVDetails;
